import type { SelectedAddressBookItems } from "~/features/quote/context/quote-address-context.tsx";
import {
	formatQuoteForUpdate,
	formatQuoteState,
} from "~/features/quote/utils/format-quote-state.ts";
import type { QuoteStateType } from "~/shared/types/quote-details-types.ts";

const buildCreateQuoteSection = (
	quoteState: QuoteStateType,
	addresses: SelectedAddressBookItems,
	isInternal: boolean,
) => {
	return formatQuoteState(quoteState, addresses, true, isInternal);
};

const buildUpdateShipmentDetailsSection = (
	quoteState: QuoteStateType,
	addresses: SelectedAddressBookItems,
) => {
	return formatQuoteForUpdate(quoteState, addresses);
};

export const formatLtlTenderFlowBody = (
	quoteState: QuoteStateType,
	addresses: SelectedAddressBookItems,
	isInternal: boolean,
	estimatedFreightClassIdProvided = false,
) => {
	const createQuote = buildCreateQuoteSection(
		quoteState,
		addresses,
		isInternal,
	);
	const updateShipmentDetails = buildUpdateShipmentDetailsSection(
		quoteState,
		addresses,
	);

	const { insuranceValue, insuranceProductTypeId } = quoteState;
	const saveInsuranceSelection =
		insuranceValue != null &&
		insuranceValue > 0 &&
		insuranceProductTypeId != null
			? { insuranceValue, insuranceProductTypeId }
			: undefined;

	return {
		createQuote,
		updateShipmentDetails,
		saveInsuranceSelection,
		// Signals to the backend that the freight class(es) sent were the
		// system-estimated class rather than a user selection.
		estimatedFreightClassIdProvided,
	};
};
